import { http } from "api/http";
import axios from "axios";
const createCompany = ({ name, mobileNumber }) => {
  return http.post('/vider-connect/create-company',
    { name, mobileNumber }
  )
}
const generateQR = ({ companyId }) => {
  return http.post("vider-connect/generateQR", { companyId });
};

const getOrganizationState = () => {
  return http.get("vider-connect/state");
};

const syncMessages = ({ companyId }) => {
  return http.post("vider-connect/syncMessages", { companyId });
};

const syncContacts = ({ companyId }) => {
  return http.post("vider-connect/syncContacts", { companyId });
}

const getContacts = (companyId: any) => {
  return http.get(`vider-connect/getContacts/${companyId}`);
};
const getCompanyMessages = (companyId: any) => {
  return http.get(`vider-connect/recent-messages/${companyId}`);
};

export const createSSEConnection = (companyId: string) => {
  const baseURL = http.defaults.baseURL || process.env.REACT_APP_API_URL || "";
  return new EventSource(
    `${baseURL}/whatsapp/events/${companyId}`,
    { withCredentials: true }
  );
};

const sendWhatsappMessage = (payload: {
  companyId: string;
  number: string;
  message: string;
  endSignature?: any;
  attachment?: any;
}) => {
  return http.post('/vider-connect/sendMessage', payload);
};



const requestViderConnectAccess = (data: any) => {
  return http.post('/vider-connect/sendviderConnectRequest', data);
};

const checkViderConnectAccess = () => {
  return http.get('/vider-connect/checkViderConnectAccess');
};

const getCompanyStatus = (companyId: any) => {
  return http.get(`/vider-connect/status/${companyId}`);
};

const deleteWhatsappMessage = (payload: {
  companyId: string;
  messageId: string;
  forEveryone?: boolean;
}) => {
  return http.post('/vider-connect/deleteMessage', payload);
};
const initWhatsapp = (companyId: string) => {
  return http.post('/vider-connect/whatsapp/init', { companyId });
};
const getViderConnectQr = ({ orgId }: { orgId: string }) => {
  return http.get(`vider-connect/getviderconnectqr`, {
    params: { orgId }
  });
};

const editWhatsappMessage = (payload: {
  companyId: string;
  messageId: string;
  newContent: string;
}) => {
  return http.put('/vider-connect/message/edit', payload);
};
const getVpingCredentials = () => {
  return http.get('/vider-connect/vping-credentials');
};

const launchViderConnect = () => {
  return http.post('/vider-connect/launch');
};


export { generateQR, getOrganizationState, syncMessages, syncContacts, getCompanyMessages, sendWhatsappMessage, createCompany, getContacts, requestViderConnectAccess, checkViderConnectAccess, getCompanyStatus, deleteWhatsappMessage, initWhatsapp, getViderConnectQr, editWhatsappMessage, getVpingCredentials, launchViderConnect };
